import { designationService } from "../../../../Api/Services/DesignationService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";
import {
  ICreateDesignationPayload,
  ICreateDesignationResponse,
} from "../../types";

export const saveDesignation = createServiceAsyncThunk<
  ICreateDesignationResponse,
  ICreateDesignationPayload
>(
  ACTION_NAMES.SAVE_UPDATE_DESIGNATION,
  (payload) => designationService.saveDesignation(payload),
  ERROR_MESSAGES.SAVE_UPDATE_DESIGNATION_FAILURE
);

const saveUpdateDesignationSlice = createGenericSlice<
  ICreateDesignationResponse,
  ICreateDesignationPayload
>(SLICE_NAMES.SAVE_UPDATE_DESIGNATION_SLICE, saveDesignation);

export const {
  clearError: clearSaveDesignationError,
  clearSuccessMessage: clearSaveDesignationSuccessMessage,
} = saveUpdateDesignationSlice.actions;

export default saveUpdateDesignationSlice.reducer;
